export enum ChannelContactPeriod {
  WEEKDAY = 'WEEKDAY',
  WEEKEND = 'WEEKEND',
  CUSTOM = 'CUSTOM',
}
